export const CheckboxIcon = () => (
  <svg viewBox="0 0 32 32">
    <path
      d="M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V6H26Z"
      fill="currentColor"
    />
  </svg>
);
